import { useEffect, useState } from "react";
import { Trash2, MailOpen, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Loading } from "../../components/PageHeader";
import { AdminTitle, Pill, ErrorBox } from "./AdminLayout";

function Message({ m, onChange, onDelete }) {
  const [open, setOpen] = useState(false);
  const setRead = async (read) => {
    try { onChange(await api.patch(`/admin/messages/${m.id}`, { read }).then((r) => r.data)); } catch (e) { toast.error(errMsg(e)); }
  };
  const expand = () => { setOpen(!open); if (!m.read) setRead(true); };
  const del = async () => {
    if (!window.confirm("Delete this message?")) return;
    try { await api.delete(`/admin/messages/${m.id}`); onDelete(m.id); toast.success("Message deleted"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className={`wb-card p-5 transition-colors ${m.read ? "" : "border-[color:var(--wb-line-accent)]"}`} data-testid={`message-${m.id}`}>
      <div className="flex items-start gap-4">
        <button onClick={expand} className="flex-1 text-left" data-testid="message-toggle">
          <div className="flex flex-wrap items-center gap-3">
            {!m.read && <Pill tone="gold" testid="message-unread-pill">New</Pill>}
            <span className="font-display text-xl">{m.subject}</span>
          </div>
          <div className="mt-1 text-xs muted">{m.name} · {m.email} · {new Date(m.created_at).toLocaleString()}</div>
        </button>
        <button onClick={() => setRead(!m.read)} className="p-2 muted hover:text-wb-gold" aria-label="Toggle read" data-testid="message-read-toggle">{m.read ? <Mail size={15} /> : <MailOpen size={15} />}</button>
        <button onClick={del} className="p-2 muted hover:text-red-400" aria-label="Delete" data-testid="message-delete-button"><Trash2 size={15} /></button>
      </div>
      {open && (
        <div className="mt-5 border-t wb-line pt-5">
          <p className="whitespace-pre-wrap text-sm leading-relaxed" data-testid="message-body">{m.message}</p>
          <a href={`mailto:${m.email}?subject=Re: ${encodeURIComponent(m.subject)}`} className="btn-ghost mt-5" data-testid="message-reply-link">Reply by email</a>
        </div>
      )}
    </div>
  );
}

export default function AdminMessages() {
  const [items, setItems] = useState(null);
  const [unread, setUnread] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/admin/messages", { params: { unread: unread || undefined } }).then((r) => setItems(r.data)).catch((e) => setErr(errMsg(e))); }, [unread]);
  const onChange = (m) => setItems((p) => p.map((x) => (x.id === m.id ? m : x)));
  const onDelete = (id) => setItems((p) => p.filter((x) => x.id !== id));
  return (
    <div data-testid="admin-messages">
      <AdminTitle eyebrow="Inbox" title="Contact messages">
        <label className="flex items-center gap-2 text-xs muted"><input type="checkbox" className="accent-[#D4AF37]" checked={unread} onChange={(e) => setUnread(e.target.checked)} data-testid="messages-unread-filter" /> Unread only</label>
      </AdminTitle>
      {err ? <ErrorBox msg={err} /> : !items ? <Loading /> : items.length === 0 ? <p className="py-10 muted" data-testid="messages-empty">The inbox is empty.</p> : (
        <div className="space-y-4">{items.map((m) => <Message key={m.id} m={m} onChange={onChange} onDelete={onDelete} />)}</div>
      )}
    </div>
  );
}
